import type { POICategory } from "./types";

export const DEFAULT_MIN_ZOOM = 6; // Default minimum zoom level for the map
export const DEFAULT_MAX_ZOOM = 17; // Default maximum zoom level for the map

export const MAX_POI_LIMIT = 500;

export const MAP_PADDING = {
  desktop: {
    top: 30,
    bottom: 30,
    left: 30,
    right: 30,
  },
  mobile: {
    top: 15,
    bottom: 15,
    left: 15,
    right: 15,
  },
};

export const categories: POICategory[] = [
  "primary_schools",
  "high_schools",
  "restaurants",
  "groceries",
  "groceries_specialized",
  "non_food_shops",
  "nightlife",
  "cafes",
  "daycares",
  "bus_stops",
  "rapid_transit_stations",
  "train_stations",
  "parks",
  "fitness",
  "sport_facilities",
  "health_care",
  "pet_care",
  "car_fueling_stations",
  "art_culture_science",
  "home_improvement",
  "personal_care",
];
